<template>
  <div style="width: 100%;">
         <v-row>
      <v-col>
    <v-container fluid>
      <v-row>
        <v-col class='d-flex flex-row align-center'>
          <v-btn text class="mx-2" @click="()=>{this.$router.go(-1)}">
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          <h1>{{this.singular}}: {{this.data.name}}</h1>
          <v-progress-circular
            indeterminate
            color="green"
            v-if="loader"
            style="margin-left: 10px;"
          ></v-progress-circular>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn v-if="isAllowed('productTag','u')" @click="isEditable = !isEditable">
            <span v-if="this.isEditable">Cancel</span>
            <span v-else>Edit</span>
          </v-btn>
        </v-col>
      </v-row>
      <v-form :disabled="!isEditable">
        <v-row>
          <v-col>
            <v-text-field
                label="Name"
                outlined
                v-model="data.name"
            />
            <v-text-field
                label="Slug"
                outlined
                v-model="data.slug"
                persistent-hint
                hint="Spaces within the Slug will be replaced with '-' automatically."
            />
            <v-text-field
                label="Description"
                outlined
                v-model="data.description"
            />
          </v-col>
        </v-row>
      </v-form>
      <v-row>
        <v-col v-if="isEditable">
          <v-btn @click="update">Save</v-btn>
          <v-btn v-if="isAllowed('productTag','d')" style="margin-left: 10px;" class="error" @click="deleteData">Delete</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <hr>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex flex-row align-center">
          <h1>Products</h1>
          <v-progress-circular
              indeterminate
              color="green"
              v-if="loader"
              style="margin-left: 10px;"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-data-table mobile-breakpoint="0"
              :headers="secondaryHeaders"
              :items="data.Products"
              :items-per-page="-1"
              class="elevation-1"
              @click:row="secondaryRowClick"
              @mousedown:row="secondaryRowMiddleClick"
          />
        </v-col>
      </v-row>
    </v-container>
      </v-col>
     </v-row>
  </div>
</template>
<script>
  import axios from 'axios';
  import utils  from "../../plugins/helpers"
  import {mapGetters} from "vuex";
  export default {
    data () {
      return {
        utils: utils,
        deleteDialog: false,
        deleteConfirmed: true,
        loader: true,

        max25chars: v => v.length <= 25 || 'Input too long!',
        editMode: false,
        data: {},
        singular: "Product Tag",
        singularLower: "producttag",
        plural: "Product Tags",
        pluralLower: "producttags",
        isEditable: false,
        secondaryHeaders: [
          {
            text: 'Product',
            align: 'start',
            sortable: true,
            value: 'name',
          },
          { text: 'Description', value: "description"},
          { text: 'Price', value: "price"},
          { text: 'SKU', value: "sku"}
        ],
      }
    },
    async mounted(){
        await this.getAllData();
    },
    computed: {
      ...mapGetters(['getEndpoint', "isAllowed"])
    },
    methods: {
      async update(){
        try {
          this.loader = true;
          await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/${this.$route.params.id}`, this.data)

          this.$snack(`${this.singular} Updated 🎉`, "success");
          this.data={};
          await this.getAllData();
          this.isEditable = false;
        } finally {
          this.loader = false;
        }
      },
      async deleteData(){
        try {
          this.loader = true
          await axios.delete(`${this.getEndpoint}/api/${this.pluralLower}/${this.$route.params.id}`)

          this.$snack(`${this.singular} Deleted 🎉`, "success");
          await this.$router.go(-1);
        } finally {
          this.loader = false
        }
      },
      secondaryRowClick(row){
        this.$router.push({ path: `/products/view/${row.id}`})
      },
      async secondaryRowMiddleClick(event, row){
        if(!row.item) return;
        row = row.item;

        if (event.button === 1) {
          event.preventDefault();
          this.utils.openInNewTab(this.$router,`/products/view/${row.id}`)
        }
      },
      async getAllData(){
        try {
          this.loader = true;
          let res = await axios.get(`${this.getEndpoint}/api/${this.pluralLower}/${this.$route.params.id}`)

          this.data = res.data.data
        } finally {
          this.loader = false;
        }
      }
    }
  }
</script>
